import { render, staticRenderFns } from "./CardMock.vue?vue&type=template&id=1b81f8c8&scoped=true"
import script from "./CardMock.vue?vue&type=script&lang=js"
export * from "./CardMock.vue?vue&type=script&lang=js"
import style0 from "./CardMock.vue?vue&type=style&index=0&id=1b81f8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81f8c8",
  null
  
)

export default component.exports